<script setup lang="ts">
import { useLoginStore } from "../stores/login";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const loginStore = useLoginStore();
const router = useRouter();

onMounted(() => {
    loginStore.logout();
    router.push({ path: "/" });
});

</script>

<template><div /></template>
